import { registerPopup } from './agreement/agreement-popup';

registerPopup();
